import React, { Suspense, useState } from 'react';
import { CrewMember, OwnershipLevel } from '@bechtel/types';
import { ErrorBoundary, UnderConstruction, SuspenseLoader, CacheKeys, useSessionStorage } from '@bechtel/client-common';
import { DashboardHeader } from '~/header';
import { DashboardPersonaContainerStyled } from '~/styled';
import { useDashboardPermissions, UserSelector } from '@bechtel/client-dashboard-common';
import { DashboardContainerStyled } from './styled';
import { DashboardContent } from '~/content';

const DashboardView = () => {
  const [selectedCrewMember, setSelectedCrewMember] = useSessionStorage<CrewMember | null>(
    CacheKeys.DashboardSelectedUser,
    null
  );
  //All the dashboard default canView properties are mutually exclusive only one or none will be true at a time
  const { canViewOtherUserDashboard, hasNoDefaultDashboard } = useDashboardPermissions();

  const [selectedOwnershipLevel, setSelectedOwnershipLevel] = useState<OwnershipLevel>(OwnershipLevel.PRIMARY);

  return (
    <DashboardContainerStyled>
      {hasNoDefaultDashboard ? (
        <UnderConstruction />
      ) : (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <DashboardPersonaContainerStyled>
              <DashboardHeader selectedOwnershipLevel={selectedOwnershipLevel} setSelectedOwnershipLevel={setSelectedOwnershipLevel} />
              {canViewOtherUserDashboard && (
                <UserSelector selectedCrewMember={selectedCrewMember} setSelectedCrewMember={setSelectedCrewMember} />
              )}
              <DashboardContent selectedCrewMember={selectedCrewMember} selectedOwnershipLevel={selectedOwnershipLevel} />
            </DashboardPersonaContainerStyled>
          </Suspense>
        </ErrorBoundary>
      )}
    </DashboardContainerStyled>
  );
};

export default DashboardView;
